import { render, staticRenderFns } from "./MyWalletMobile.vue?vue&type=template&id=3a4f07e2&scoped=true"
import script from "./MyWalletMobile.vue?vue&type=script&lang=js"
export * from "./MyWalletMobile.vue?vue&type=script&lang=js"
import style0 from "./MyWalletMobile.vue?vue&type=style&index=0&id=3a4f07e2&prod&scoped=true&lang=scss"
import style1 from "./MyWalletMobile.vue?vue&type=style&index=1&id=3a4f07e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4f07e2",
  null
  
)

export default component.exports